// extracted by mini-css-extract-plugin
export default {"wrapper":"tW-z","firstToReview":"uW-z","productCards":"vW-z","productCard":"wW-z","stars":"xW-z","hidden":"yW-z"};